import { render, staticRenderFns } from "./EstimageMessageListSideMenu.vue?vue&type=template&id=5f0a8f5f&scoped=true"
import script from "./EstimageMessageListSideMenu.vue?vue&type=script&lang=js"
export * from "./EstimageMessageListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./EstimageMessageListSideMenu.vue?vue&type=style&index=0&id=5f0a8f5f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0a8f5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f0a8f5f')) {
      api.createRecord('5f0a8f5f', component.options)
    } else {
      api.reload('5f0a8f5f', component.options)
    }
    module.hot.accept("./EstimageMessageListSideMenu.vue?vue&type=template&id=5f0a8f5f&scoped=true", function () {
      api.rerender('5f0a8f5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/estimagemessage/EstimageMessageListSideMenu.vue"
export default component.exports